export default __webpack_public_path__ + "static/media/Recog 10.9694d8f1.pdf";